import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const FullLoader = ({ isLoading }) => {
  if (!isLoading) return null;

  const whiteSpinner = (
    <LoadingOutlined style={{ fontSize: 40, color: "black" }} spin />
  );

  return (
    <div
      className="absolute inset-0 flex items-center justify-center bg-white"
      role="status"
      aria-live="polite"
    >
      <Spin indicator={whiteSpinner} />
    </div>
  );
};

export default FullLoader;
